
import Navbar from "../DashboardNavbar";
import CompliceSidebar from "../CompliceSidebar.jsx"


const Layout = ({ children }) => {

  return (
    <>
      <div className="layout">
        <div className="container-fluid m-0 g-0 p-0">
          <div className="navbarStyle ">
            <Navbar />
          </div>

          <div className="otherPage">
            <div>
              <CompliceSidebar/>
            </div>
            <div className="pages">{children}</div>
          </div>
          <div>
          
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;